export const normalizeItemFromArticle = (item) => {
  return {
    id: item.id,
    type: 'article',
    title: item.title,
    excerpt: item.excerpt,
    slug: item.slug,
    link: `/blog/${item.base_path}/${item.slug}`,
    image: item.image
  }
}

export const normalizeItemFromArticleCategory = (item) => {
  return {
    id: item.id,
    type: 'article-category',
    title: item.title,
    excerpt: '',
    slug: item.slug,
    link: `/blog`,
    image: item.image
  }
}

export const normalizeItemFromProduct = (item) => {
  return {
    id: item.id,
    type: 'product',
    product: item,
    title: item.title,
    excerpt: '',
    slug: item.slug,
    link: `/tienda/${item.categories[0].slug}/${item.slug}`,
    variants: item.variants,
    image: getProductDefaultImage(item)?.image
  }
}

export const normalizeItemFromProductCategory = (item) => {
  return {
    type: 'product-category',
    id: item.id,
    title: item.title,
    excerpt: '',
    slug: item.slug,
    link: `/tienda/${item.slug}`,
    image: item.image
  }
}
